import { createApp } from 'vue'
import App from './App.vue'
import '@/assets/scss/tailwind.scss'
import '@/assets/libs/@mdi/font/css/materialdesignicons.min.css'
import '@/assets/libs/tobii/css/tobii.min.css'
import { createPinia } from 'pinia'
import VueEasyLightbox from 'vue-easy-lightbox'
import router from './router'
import store from './store'

import dayjs from 'dayjs'
import 'dayjs/locale/es'
const localizedFormat = require('dayjs/plugin/localizedFormat')
dayjs.locale('es')
dayjs.extend(localizedFormat)

//instancia de componentes
import IconEye from './components/icons/iconEye.vue'
import IconHeart from './components/icons/iconHeart.vue'

//->ICONOS
import { OhVueIcon, addIcons } from 'oh-vue-icons'
import {
  BiHeartFill,
  BiEyeFill,
  BiEyeSlashFill,
  BiCart,
  BiCart3,
  CoFacebookF,
  BiInstagram,
  MdEmailOutlined,
  IoBagHandleOutline,
  BiSearch,
  BiTelephone,
  CoLocationPin,
  CoTruck,
  LaUserClockSolid,
  FaHandHoldingUsd,
  BiCheckCircle,
  CoWarning,
  RiErrorWarningLine,
  IoCloseCircleOutline,
} from 'oh-vue-icons/icons'

addIcons(
  BiHeartFill,
  BiEyeFill,
  BiEyeSlashFill,
  BiCart,
  BiCart3,
  CoFacebookF,
  BiInstagram,
  MdEmailOutlined,
  IoBagHandleOutline,
  BiSearch,
  BiTelephone,
  CoLocationPin,
  CoTruck,
  LaUserClockSolid,
  FaHandHoldingUsd,
  BiCheckCircle,
  CoWarning,
  RiErrorWarningLine,
  IoCloseCircleOutline
)

const app = createApp(App)

app.use(VueEasyLightbox)
app.use(createPinia())
app.use(router)
app.use(store)

//componentes
app.component('v-icon', OhVueIcon)
app.component('IconEye', IconEye)
app.component('IconHeart', IconHeart)
app.mount('#app')
